import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from '@taxdown/piccolo-web';
import Notify, { AlertTypes } from 'Services/notification';
import { locizeNS } from 'Services/i18n';
import { hideModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { formatPDF } from 'Utils/formatPdf';
import View from './view';

const PdfIframe = ({ pdfUrl, cepFile }: { pdfUrl: string; cepFile: string }): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const [base64Pdf, setPdf] = useState<string | null>(null);
  const [base64Binary, setBase64Binary] = useState<string>('');
  const [fileType, setFileType] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData(): Promise<void> {
      try {
        const response = await formatPDF(pdfUrl);
        const url = `data:application/pdf;base64,${response}`;
        setPdf(url);
        setBase64Binary(response);
        setFileType('pdf');
      } catch (error) {
        Notify.sendNotification(t('dashboard:PDF.download.success'), AlertTypes.error);
        dispatch(hideModalAction());
      }
    }
    if (pdfUrl) {
      fetchData();
    } else if (cepFile) {
      const url = cepFile;
      setPdf(url);
      setBase64Binary(cepFile);
      setFileType('cep');
    }
  }, []);

  return !base64Pdf ? (
    <Spinner size="L" justify="center" />
  ) : (
    <View base64Pdf={base64Pdf} base64Binary={base64Binary} fileType={fileType} />
  );
};

export default PdfIframe;
